import React, { Component } from 'react'
import { shape, func, string, bool } from 'prop-types'
import { Button, CheckBox, FlagDropdown, InputBox } from 'components'
import { trackSignalEvent } from 'services/utils/analytics'
import { getQueryParameter, isValidWebViewScreen } from 'services/utils/strings'
import {
  PHONE_FORM_ERROR,
  EMAIL_FORM_ERROR,
  PASSWORD_FORM_ERROR,
  USERNAME_EMPTY_ERROR,
} from 'services/utils/constants/validations'
import { isNumber, validatePhoneNumber, validateEmail, enchanceUsername } from 'services/utils/validations'
import { locations, phoneNumberMaxLength } from 'services/utils/common'
import history from 'services/utils/history'
import RecaptchaBlock from '../recaptcha'
import Password from '../../../components/password'
import LoginDisclaimer from '../login-disclaimer'

class LoginForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      rememberMe: true,
      isEmptyUserName: false,
      isValidEmail: true,
      passwordError: false,
      loading: false,
      isPhoneNumber: false,
      countryCode: '+44',
      flagTitle: this.extractFlagTitle('+44'),
      isValidPhoneNumber: true,
    }
    this.testPass = ''
  }

  componentDidMount() {
    const emailHash = getQueryParameter('email', window.location.href, true)
    const { decryptEmail } = this.props.decryptEmailActions
    /* istanbul ignore else */
    if (emailHash) {
      decryptEmail(emailHash)
    }
  }

  extractFlagTitle = (countryCode) => {
    const dialCode = countryCode && countryCode.slice(1)
    const location = locations.find(location => location.dialcode === dialCode)
    return (location && location.iso2) || 'gb'
  }

  onInputChange = (e) => {
    const { target: { value } } = e
    const { isPhoneNumber, countryCode } = this.state
    const username = enchanceUsername(value, isPhoneNumber, countryCode)
    this.setState({
      username,
      isEmptyUserName: false,
      isValidEmail: true,
      isValidPhoneNumber: true,
      isPhoneNumber: value ? isNumber(value) : isPhoneNumber,
      flagTitle: this.extractFlagTitle(countryCode),
    })
  }

  onPasswordChange = (e) => {
    const { target: { value } } = e
    this.setState({
      password: value,
      passwordError: false,
    })
  }

  componentWillReceiveProps = (nextProps) => {
    const {
      login: {
        isLoginError,
      },
      user: {
        email: newEmail,
      },
      decryptEmail: {
        decryptedEmail,
      },
      resetPassword: {
        noSuchUserError,
        error,
        step,
        email,
      },
      ui: {
        isFetching,
      },
    } = nextProps
    const { redirect_uri: redirectUri, requestOrigin = 'asda' } = this.props.ui
    const isWebView = isValidWebViewScreen()
    const resetPasswordUri = `/reset-password?request_origin=${requestOrigin}${isWebView ? `&web_view=reset-password` : ''}`
    const resetPasswordLink = redirectUri ? `${resetPasswordUri}&redirect_uri=${encodeURIComponent(redirectUri)}` : resetPasswordUri
    const { username } = this.state
    if (!username && newEmail) {
      this.setState({ username: newEmail })
    }
    if (isLoginError) {
      this.setState({ loading: false })
    }
    if (decryptedEmail) {
      this.setState({ username: decryptedEmail })
    }
    if ((noSuchUserError || error || step) && !isFetching && email) {
      const redirectLink = `${resetPasswordLink}&step=2`
      history.push(redirectLink)
    }
  }

  setCountryCode = countryCode => this.setState({ countryCode })

  loginForm() {
    const {
      username,
      password,
      isEmptyUserName,
      passwordError,
      isPhoneNumber,
      isValidPhoneNumber,
      isValidEmail,
    } = this.state
    const { isLoginError, errorDescription } = this.props.login
    const { user: { isUserActive }, ui: { isThirdParty } } = this.props
    const { countryCode, flagTitle } = this.state
    return (
      <form
        method="post"
        action="#"
        className={isUserActive ? 'softLogin-form' : ''}
        onSubmit={this.onFormSubmit}
        aria-label="Login Form"
      >
        <label className="for-username">Email or phone number</label>
        <div className={`username-box ${isPhoneNumber ? 'phone-input' : ''} ${!isValidPhoneNumber ? 'error' : ''}`}>
          {isPhoneNumber ? <FlagDropdown
            titleCode={countryCode}
            titleFlag={flagTitle}
            list={locations}
            setCountryCode={this.setCountryCode}
            className="dropdown"
            isLogin
          /> : null}
          <InputBox
            type="text"
            value={username}
            onChange={this.onInputChange}
            hasError={isEmptyUserName || !isValidPhoneNumber || !isValidEmail}
            className='email-phone-input'
            errorMsg={this.getErrorMessage()}
            autoComplete="on"
            maxLength={isPhoneNumber ? phoneNumberMaxLength(countryCode) : '255'}
            tabOrder={4}
            ariaLabel='Email or phone number'
          />
        </div>
        <Password
          value={password}
          onChange={this.onPasswordChange}
          hasError={passwordError}
          errorMsg={passwordError ? PASSWORD_FORM_ERROR : null}
          autofocus={isUserActive || null}
          id="password"
        />
        {isLoginError && <div role="alert" className="form-error">{errorDescription}</div>}
        <div className='login-links'>
          <Button
            className="reset-pwd right"
            type="button"
            onClick={this.handleResetPassword}
          >
            Forgotten password
          </Button>
          <CheckBox
            label="Remember me"
            defaultChecked={this.state.rememberMe}
            handleChange={this.handleRememberMe}
            className="remember-me"
          />
        </div>
        <Button
          className="primary full"
          onClick={() => false}
          loading={this.state.loading}
        >
          Sign in
        </Button>
        {isThirdParty ? <LoginDisclaimer {...this.props.ui} /> : null}
      </form>
    )
  }
  onFormSubmit = (e) => {
    e.preventDefault()
    const {
      username, password, rememberMe, countryCode, isPhoneNumber,
    } = this.state
    const { loginActions: { loginUser, clearErrorStates }, ui } = this.props
    const {
      redirectUri,
      isThirdParty,
      clientId,
      requestOrigin,
    } = ui
    clearErrorStates()
    if (!this.hasError()) {
      const params = { requestorigin: isThirdParty || requestOrigin }
      const formData = {
        username,
        password,
        redirectUri,
        rememberMe: rememberMe ? 'Y' : 'N',
        isPhoneNumber,
        ...(isThirdParty ? { method: 'authorization', clientId } : { method: 'authentication' }),
        ...(isPhoneNumber ? { countryCode } : { }),
      }
      this.setState({
        loading: true,
      })
      loginUser(formData, params)
    }
  }
  handleRememberMe=() => {
    this.setState(prevState => ({
      rememberMe: !prevState.rememberMe,
    }))
  }
  handleResetPassword = () => {
    const { username } = this.state
    const { ui, resetPasswordActions } = this.props
    const { redirectUri, requestOrigin = 'asda' } = ui
    const isWebView = isValidWebViewScreen()
    const resetPasswordUri = `/reset-password?request_origin=${requestOrigin}${isWebView ? `&web_view=reset-password` : ''}`
    const resetPasswordLink = redirectUri ? `${resetPasswordUri}&redirect_uri=${encodeURIComponent(redirectUri)}` : resetPasswordUri
    if (username) {
      if (!validateEmail(username)) history.push(resetPasswordLink)
      else {
        const { submitResetForm } = resetPasswordActions
        submitResetForm({ step: 'ENTER_EMAIL', email: username })
      }
    } else history.push(resetPasswordLink)
    trackSignalEvent('forgotPasswordClick')
  }
  hasError() {
    // checking for error
    let hasError = false
    const {
      username, password, isPhoneNumber, countryCode,
    } = this.state
    if (isPhoneNumber) {
      const { isValidPhoneNumber } = validatePhoneNumber(username, countryCode)
      this.setState({ isValidPhoneNumber })
      hasError = !isValidPhoneNumber
    } else {
      const isValidEmail = validateEmail(username)
      this.setState({ isValidEmail })
      hasError = !isValidEmail
    }
    if (!username) {
      this.setState({
        isEmptyUserName: true,
      })
      hasError = true
    }
    /* istanbul ignore else */
    if (!password) {
      this.setState({
        passwordError: true,
      })
      hasError = true
    }
    return hasError
  }

  getErrorMessage = () => {
    const { isEmptyUserName, isValidEmail } = this.state
    if (isEmptyUserName) {
      return USERNAME_EMPTY_ERROR
    }
    return !isValidEmail ? EMAIL_FORM_ERROR : PHONE_FORM_ERROR
  }

  render() {
    const { login: { isPerimeterXEnabled } } = this.props
    return isPerimeterXEnabled ? (
      <RecaptchaBlock
        {...this.props}
        formData={this.state}
      />
    ) : (this.loginForm())
  }
}

LoginForm.propTypes = {
  onTypeChange: func,
  loginActions: shape({
    loginUser: func,
    georgeLogin: func,
    clearErrorStates: func,
  }),
  decryptEmailActions: shape({
    decryptEmail: func,
  }),
  decryptEmail: shape({
    decryptedEmail: string,
  }),
  user: shape({
    email: string,
  }),
  ui: shape({
    redirectUri: string,
    isThirdParty: bool,
    clientId: string,
    requestOrigin: string,
    isFetching: bool,
  }),
  login: shape({
    errorDescription: string,
  }),
  resetPasswordActions: shape({
    submitResetForm: func,
  }),
  resetPassword: shape({
    step: string,
  }),
}

LoginForm.defaultProps = {
  onTypeChange: () => { },
  loginActions: {
    loginUser: () => { },
    georgeLogin: () => { },
    clearErrorStates: () => { },
  },
  decryptEmailActions: {
    decryptEmail: x => x,
  },
  decryptEmail: {
    decryptedEmail: '',
  },
  user: {
    email: '',
  },
  ui: {
    redirectUri: '',
    isThirdParty: false,
    clientId: '',
    requestOrigin: '',
    isFetching: false,
  },
  login: {
    errorDescription: '',
  },
  resetPasswordActions: {
    submitResetForm: () => {},
  },
  resetPassword: {
    step: '',
  },
}

export default LoginForm
